import { CFormCheck } from '@coreui/react-pro'
import { useField } from 'formik'

export const FormCheckInput = ({ ...props }) => {
  const [field, meta] = useField(props)

  const isValid = !!(meta.touched && meta.error)
  const feedbackMsg = isValid ? meta.error : ''

  return (
    <CFormCheck
      {...field}
      {...props}
      invalid={isValid}
      valid={meta.touched && !isValid}
      feedbackInvalid={feedbackMsg}
    />
  )
}
